import { render } from "./puesto.vue?vue&type=template&id=6e5fb0ba"
import script from "./puesto.vue?vue&type=script&lang=js"
export * from "./puesto.vue?vue&type=script&lang=js"

import "./puesto.vue?vue&type=style&index=0&id=6e5fb0ba&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__